import { useEffect, useState } from 'react';

/**
 * Détecte si la fenêtre est assez large pour afficher la navigation latérale.
 *
 * Pourquoi un hook plutôt qu'une simple classe `hidden md:flex` ?
 * Certaines feuilles de style de thème injectées globalement peuvent écraser
 * les utilitaires de largeur. Ici on mesure la fenêtre réelle et on applique
 * un style explicite : le menu de gauche est donc toujours visible sur PC.
 */
export default function useIsDesktop(breakpoint = 768): boolean {
  const read = (): boolean => {
    if (typeof window === 'undefined' || typeof document === 'undefined') return true;
    const width = window.innerWidth || document.documentElement.clientWidth || 0;
    if (width >= breakpoint) return true;
    try {
      return window.matchMedia(`(min-width: ${breakpoint}px)`).matches;
    } catch {
      return false;
    }
  };

  const [isDesktop, setIsDesktop] = useState<boolean>(read);

  useEffect(() => {
    const update = () => setIsDesktop(read());
    update();
    window.addEventListener('resize', update);
    window.addEventListener('orientationchange', update);
    return () => {
      window.removeEventListener('resize', update);
      window.removeEventListener('orientationchange', update);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [breakpoint]);

  return isDesktop;
}